import './Global.css';
import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './views/Home';
import NotFound from './views/NotFound';
import OnlineOrder from './views/OnlineOrder'
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';



// call for reservations mondays through thursdays
// no reservations on weekends or holidays

function App() {
  return (
    <BrowserRouter>
    <div id='App' className="App">
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/OnlineOrder' element={<OnlineOrder/>} />
        <Route path='*' element={<NotFound/>} />
      </Routes>
      <Footer/>
    </div>
    </BrowserRouter>
  );
}

export default App;
